///////////////////////////////////////////////////////////////////////////////
//
//  AutobahnJS - http://autobahn.ws, http://wamp.ws
//
//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
//
//  Copyright (C) 2011-2014 Tavendo GmbH, http://tavendo.com
//
//  Licensed under the MIT License.
//  http://www.opensource.org/licenses/mit-license.php
//
///////////////////////////////////////////////////////////////////////////////
/* eslint spaced-comment:0,vars-on-top:0,no-var:0,camelcase:0,func-names:0,one-var:0,one-var-declaration-per-line:0,eqeqeq:0,
no-multiple-empty-lines:0,prefer-rest-params:0,block-scoped-var:0,no-use-before-define:0,prefer-template:0,no-restricted-syntax:0,
no-debugger:0,padded-blocks:0,no-else-return:0,quotes:0,object-curly-spacing:0,semi:0,space-infix-ops:0,no-console:0,no-underscore-dangle:0,
no-throw-literal:0,no-unneeded-ternary:0,guard-for-in:0,space-before-function-paren:0 */
/* global AUTOBAHN_DEBUG:true */

function Transports() {
    this._repository = {};
}


Transports.prototype.register = function (name, factory) {
    this._repository[name] = factory;
};


Transports.prototype.isRegistered = function (name) {
    return this._repository[name] ? true : false;
};


Transports.prototype.get = function (name) {
    if (this._repository[name] !== undefined) {
        return this._repository[name];
    } else {
        throw "no such transport: " + name;
    }
}


Transports.prototype.list = function() {
    var items = [];
    for (var name in this._repository) {
        items.push(name);
    }
    return items;
};


var _transports = new Transports();


// register default transports
var websocket = require('./transport/websocket.js');
_transports.register("websocket", websocket.Factory);

var longpoll = require('./transport/longpoll.js');
_transports.register("longpoll", longpoll.Factory);

exports.transports = _transports;



// WEBPACK FOOTER //
// ./src/lightweight-autobahn/src/configure.js